module.exports = __webpack_public_path__ + "static/media/icons_Bilan de r‚‚ducation neurologique.f7c4ee7f.svg";